module.exports = __webpack_public_path__ + "static/media/sorocred.165bc818.jpg";